module.exports = __webpack_public_path__ + "img/3-2.205a7323.svg";